import { keys, reduce, isNil, isEmpty } from "lodash";
import { ContactForm } from "@models/SIO/Contact.model";
import { Validations } from "@utils/helpers";
import { IError } from "@utils/useForm";

export const validate = (values: ContactForm) => {
  const fields = keys(values);
  const errors: any = reduce(
    fields,
    (result, field: string) => {
      return { ...result, [field]: validateField(values, field) };
    },
    {}
  );
  return errors;
};

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case "salutation":
      if (isNil(value)) {
        error = { isValid: false, message: "Please select a salutation" };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: "Please select a salutation" };
        }
      }
      break;
    case "mobileNum":
      if (isNil(value)) {
        error = { isValid: false, message: "Enter a valid 8-digit Singapore mobile number" };
      } else {
        if (value.length < 8) {
          error = { 
            isValid: false,
            message: "Enter a valid 8-digit Singapore mobile number"
          }
        } else if (value.length > 8) {
          error = {
            isValid: false,
            message: "Enter a valid 8-digit Singapore mobile number"
          };
        } else if (!["8", "9"].includes(value.charAt(0))) {
          error = {
            isValid: false,
            message: "Enter a valid 8-digit Singapore mobile number",
          };
        }
      }
      break;
    case "emailId":
      if (isNil(value)) {
        error = { isValid: false, message: "Enter in the format: example@email.com" };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: "Enter in the format: example@email.com"};
        } else {
          if (!Validations.isValidEmail(value)) {
            error = {
              isValid: false,
              message: "Enter in the format: example@email.com"
            };
          }
        }
      }
      break;
  }
  return error;
};
